import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { trackTelegramClick } from '../lib/trackTelegramClick';

const TELEGRAM_CHANNEL = 'https://t.me/uppercircuitstocksbychiragrathod';
const STORAGE_KEY = 'tg_nudge_shown';

const TelegramNudge = () => {
  const [visible, setVisible] = useState(false);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const showTimer = setTimeout(() => {
      setVisible(true);
      sessionStorage.setItem(STORAGE_KEY, '1');
      requestAnimationFrame(() => setEntered(true));
    }, 4000);
    return () => clearTimeout(showTimer);
  }, []);

  const close = () => {
    setEntered(false);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="telegram-nudge"
      className={`fixed bottom-6 left-6 z-[70] w-[calc(100vw-3rem)] max-w-sm transition-all duration-300 ease-out ${
        entered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      <div className="relative rounded-2xl bg-[#0f0f12] border border-[#229ED9]/40 shadow-[0_16px_50px_rgba(34,158,217,0.25)] p-5 pr-10 overflow-hidden">
        <div className="absolute -top-16 -right-16 w-40 h-40 bg-[#229ED9]/15 rounded-full blur-2xl pointer-events-none" aria-hidden="true" />

        <button
          onClick={close}
          aria-label="Dismiss"
          data-testid="telegram-nudge-close"
          className="absolute top-3 right-3 text-gray-500 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-3 relative">
          <div className="shrink-0 mt-0.5 w-11 h-11 rounded-full bg-[#229ED9] flex items-center justify-center shadow-[0_6px_20px_rgba(34,158,217,0.45)]">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" className="w-6 h-6">
              <path d="M23.91 3.79L20.3 20.84c-.25 1.21-.98 1.5-2 .94l-5.5-4.07-2.66 2.57c-.3.3-.55.56-1.1.56-.72 0-.6-.27-.84-.95L6.3 13.7l-5.45-1.7c-1.18-.35-1.19-1.16.26-1.75l21.26-8.2c.97-.43 1.9.24 1.53 1.73z" />
            </svg>
          </div>
          <div>
            <h3 className="text-white font-bold text-base leading-tight">
              Join 25,000+ traders on Telegram
            </h3>
            <p className="text-gray-400 text-sm mt-1">
              Free market updates, snapshots & trade ideas — straight to your phone.
            </p>
          </div>
        </div>

        <a
          href={TELEGRAM_CHANNEL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => { trackTelegramClick('nudge'); close(); }}
          data-testid="telegram-nudge-join"
          className="mt-4 flex items-center justify-center gap-2 w-full bg-[#229ED9] hover:bg-[#1c8ac2] text-white font-semibold text-sm py-2.5 rounded-xl transition-all duration-300 hover:scale-[1.02]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
            <path d="M23.91 3.79L20.3 20.84c-.25 1.21-.98 1.5-2 .94l-5.5-4.07-2.66 2.57c-.3.3-.55.56-1.1.56-.72 0-.6-.27-.84-.95L6.3 13.7l-5.45-1.7c-1.18-.35-1.19-1.16.26-1.75l21.26-8.2c.97-.43 1.9.24 1.53 1.73z" />
          </svg>
          Join Free Channel
        </a>
      </div>
    </div>
  );
};

export default TelegramNudge;
